import React from "react"; //para usar codigo html y js (jsx)
import "./MenuTop.scss"; //importar los colores y/o config. para los componentes
import { Button, Icon } from "antd"; //uso de la paqueteria AntDesign
import IsraLogo from "../../../assets/img/png/tec.png"; //importacion de la imagen png como logo
import { logout } from "../../../api/auth";

export default function MenuTop(props) {
  const { menuCollapsed, setMenuCollapsed } = props;
  const logoutUser = () => {
    logout(); //desloguea
    window.location.reload();
  };
  return (
    <div className="menu-top">
      <div className="menu-top_left">
        <img
          className="menu-top_left-logo"
          src={IsraLogo}
          alt="ISRAEL GARCIA LOPEZ"
        />
        <Button type="link" onClick={() => setMenuCollapsed(!menuCollapsed)}>
          <Icon type={menuCollapsed ? "heart" : "menu-fold"} />
        </Button>
      </div>
      <div className="menu-top_right">
        <Button type="link" onClick={logoutUser}>
          <Icon type="poweroff" />
        </Button>
      </div>
    </div>
  );
}
